import { render } from "./TheFooter.vue?vue&type=template&id=e2f53a5c&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=e2f53a5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f53a5c"]])

export default __exports__